import axios from "axios";
import { UPDATE_IDENTIFY } from "./actionTypes";

export const identify = (url) => (dispatch) => {
  const requestData = {
    url: url,
  };

  return axios
    .post("/identify", requestData)
    .then((response) => {
      return dispatch({
        type: UPDATE_IDENTIFY,
        payload: response.data.data.identify,
      });
    })
    .catch((err) => {
      console.log(
        "[Identify.actions.js] identify|| Could not fetch identify information. Try again later."
      );
    });
};
